"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyHlOnboardingStepId = exports.HlOnboardingStepId = void 0;
const CommonOnboardingStepId_1 = require("../../common/domain/CommonOnboardingStepId");
var HlOnboardingStepId;
(function (HlOnboardingStepId) {
    HlOnboardingStepId["HL_REVENUE_ESTIMATION"] = "HL_REVENUE_ESTIMATION";
    HlOnboardingStepId["HL_UPCOMING_DEPARTURE"] = "HL_UPCOMING_DEPARTURE";
    HlOnboardingStepId["HL_ACCOMMODATION_DESCRIPTION"] = "HL_ACCOMMODATION_DESCRIPTION";
    HlOnboardingStepId["HL_ACCOMMODATION_PHOTOS"] = "HL_ACCOMMODATION_PHOTOS";
    HlOnboardingStepId["HL_INVENTORY"] = "HL_INVENTORY";
    HlOnboardingStepId["HL_ADMINISTRATIVE_INFO"] = "HL_ADMINISTRATIVE_INFO";
    HlOnboardingStepId["HL_PAYMENT_PREFERENCES"] = "HL_PAYMENT_PREFERENCES";
    HlOnboardingStepId["HL_APPOINTMENT_REQUEST"] = "HL_APPOINTMENT_REQUEST";
})(HlOnboardingStepId = exports.HlOnboardingStepId || (exports.HlOnboardingStepId = {}));
exports.AnyHlOnboardingStepId = Object.assign({}, CommonOnboardingStepId_1.CommonOnboardingStepId, HlOnboardingStepId);
//# sourceMappingURL=HlOnboardingStepId.js.map